import { Backdrop, CircularProgress } from '@mui/material'

interface ILoadingOverlayProps {
  open: boolean
}

const LoadingOverlay = ({ open }: ILoadingOverlayProps) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}

export default LoadingOverlay
